module.exports = __webpack_public_path__ + "img/u207.3baebf18.svg";